import {
  Avatar,
  Flex,
  IconButton,
  Box,
  Text,
  Popover,
  PopoverTrigger,
  PopoverContent,
  VStack,
  HStack,
  Divider,
  Button,
} from "@chakra-ui/react";
import { MdMenu, MdNotifications } from "react-icons/md";
import { formatDistanceToNow } from "date-fns";

const Header = () => {
  const unreadCount = 8; // Replace with dynamic data if needed

  const notifications = [
    {
      id: 1,
      title: "Felecia Rower",
      message: "Cake pie jelly beans...",
      timestamp: "10 am",
      avatar: "https://via.placeholder.com/50",
    },
    {
      id: 2,
      title: "Adalberto Granzin",
      message: "Toffee caramels jelly-o tart...",
      timestamp: "11 am",
      avatar: "https://via.placeholder.com/50",
    },
    {
      id: 3,
      title: "Joaquina Weisenborn",
      message: "Soufflé soufflé caramels...",
      timestamp: "12 pm",
      avatar: "https://via.placeholder.com/50",
    },
    {
      id: 4,
      title: "Verla Morgano",
      message: "Chupa chups candy canes...",
      timestamp: "1 pm",
      avatar: "https://via.placeholder.com/50",
    },
    {
      id: 5,
      title: "Margot Henschke",
      message: "Cake pie jelly beans...",
      timestamp: "3 pm",
      avatar: "https://via.placeholder.com/50",
    },
  ];

  return (
    <Flex
      backgroundColor="white"
      justifyContent="flex-end"
      paddingX={4}
      paddingY={2}
      borderBottom="1px solid #E2E8F0"
      shadow="sm"
    >

      <Flex alignItems="center" gap={6}>
        {/* Notification Popover */}
        {/* <Box position="relative">
          <Popover placement="bottom-end">
            <PopoverTrigger>
              <IconButton
                aria-label="Notifications"
                icon={<MdNotifications size={24} color="grey" />}
                variant="ghost"
                size="md"
              />
            </PopoverTrigger>
            <PopoverContent
              width="450px"
              borderRadius="lg"
              border="none"
              boxShadow="2xl"
              bg="white"
              zIndex="popover"
            >
              <Box
                bgGradient="linear(to-r, purple.500, pink.500)"
                p={4}
                borderTopRadius="lg"
              >
                <Flex justifyContent="space-between" alignItems="center">
                  <Text fontWeight="bold" fontSize="lg" color="white">
                    Notification
                  </Text>
                  <Button
                    variant="link"
                    fontSize="sm"
                    fontWeight="bold"
                    color="whiteAlpha.900"
                  >
                    Mark all as read
                  </Button>
                </Flex>
              </Box>
              <VStack
                align="stretch"
                spacing={4}
                p={4}
                maxHeight="350px"
                overflowY="auto"
              >
                {notifications.map((notification) => (
                  <Box key={notification.id}>
                    <HStack align="start" spacing={3}>
                      <Avatar size="sm" src={notification.avatar} />
                      <Box flex="1">
                        <Text fontSize="sm" fontWeight="bold" noOfLines={1}>
                          {notification.title}
                        </Text>
                        <Text
                          fontSize="xs"
                          color="gray.600"
                          noOfLines={2}
                          mt={1}
                        >
                          {notification.message}
                        </Text>
                      </Box>
                      <Text
                        fontSize="xs"
                        color="gray.500"
                        whiteSpace="nowrap"
                        mt={1}
                      >
                        {notification.timestamp}
                      </Text>
                    </HStack>
                    <Divider my={3} />
                  </Box>
                ))}
              </VStack>
              <Box p={4}>
                <Button
                  width="full"
                  bg="purple.500"
                  color="white"
                  _hover={{ bg: "purple.600" }}
                  size="sm"
                >
                  View All
                </Button>
              </Box>
            </PopoverContent>
          </Popover>
          {unreadCount > 0 && (
            <Box
              position="absolute"
              top="8px"
              right="8px"
              bg="primary.500"
              color="white"
              fontSize="0.7rem"
              fontWeight="bold"
              borderRadius="full"
              minW="16px"
              minH="16px"
              display="flex"
              alignItems="center"
              justifyContent="center"
              boxShadow="0 0 8px rgba(0, 0, 0, 0.1)"
              transform="translate(50%, -50%)"
            >
              {unreadCount}
            </Box>
          )}
        </Box> */}

        {/* User Avatar */}
        <Avatar size="sm" name="Doe" bg="primary.300" />
      </Flex>
    </Flex>
  );
};

export default Header;
